module.exports = __webpack_public_path__ + "static/media/cake-pastry.81311970.png";